<template>
  <div class="home">
	<div class="indicators">
		<div><a href="#" v-scroll-to="'#video'" style="color:#333333"><i class="fas fa-circle"></i></a></div>
		<div><a href="#" v-scroll-to="'#box2'" style="color:#0066ff"><i class="fas fa-circle"></i></a></div>
		<div><a href="#" v-scroll-to="'#box3'" style="color:#33cc33"><i class="fas fa-circle"></i></a></div>
	  </div>
		<div id="video" class="video-slide"  >
			<b-carousel
				id="carousel-1"
				v-model="slide"
				:interval="2500"
				indicators
				fade
				background="transparent"
				no-hover-pause
			>	
				<b-carousel-slide :img-src="slide.url"  v-for="(slide, index) in slides" :key="index"></b-carousel-slide>				
			</b-carousel>

		 <div class="overlay">
		 	<div @click="getPage(row1[3])" class="box-link">
			 	<h1 class="animated fadeInRight" v-if="row1 && row1[0] && row1[0].value">{{ row1[0].value }}</h1><br />
			 	<h1 class="animated fadeInRight" v-if="slide > 0 && row1 && row1[1] && row1[1].value">{{ row1[1].value }}</h1><br />
			 	<h1 class="animated fadeInRight" v-if="slide > 1 && row1 && row1[2] && row1[2].value">{{ row1[2].value }}<img src="../assets/royalblue-cnr.png" width="25"></h1>
		 	</div>
		 	<a class="animated fadeIn box2arrow" v-show="slide > 1" href="#" v-scroll-to="'#box2'"><i class="fas fa-arrow-down fa-2x"></i></a>
		 </div>
	  </div>
	  <div class="blue-triangle">&nbsp;</div>
	  <div id="box2" class="box-2" :style="(row2 && row2.image && row2.image[0] && row2.image[0].url)?'background-image:url('+row2.image[0].url+')':''">
	  	<div class="container">
	  		<div class="row" >
	  			<div class="col-sm-4">
	  				&nbsp;
	  			</div>
	  			<div class="col-sm-6 capabilities-text">

	  				<a href="#" v-scroll-to="'#video'"><i class="fas fa-arrow-up fa-2x"></i></a>
	  				<div @click="getPage(row2)" class="box-link">
		  				<h6 v-if="row2 && row2.text && row2.text[0] && row2.text[0].value">{{ row2.text[0].value }} </h6>
		  				<h3 v-if="row2 && row2.text && row2.text[1] && row2.text[1].value">{{ row2.text[1].value }}&nbsp;&nbsp;<img src="../assets/white-cnr.png" width="15"></h3>
	  				</div>
	  				<a href="#" v-scroll-to="'#box3'" class="box2anchor"><i class="fas fa-arrow-down fa-2x"></i></a>
	  				
	  			</div>
	  			<div class="col-sm-2"></div>
	  		</div>
	  	</div>
	  </div>
	  <div class="grey-triangle">&nbsp;</div>
	  <div id="box3" class="box-3" :style="(row3 && row3.image && row3.image[0] && row3.image[0].url)?'background-image:url('+row3.image[0].url+')':''">
	  	<div class="container">
	  		<div class="row">
	  			<div class="col-md-6 box3text">
	  				<a href="#" v-scroll-to="'#box2'"><i class="fas fa-arrow-up fa-2x"></i></a>
	  				<div @click="getPage(row3)" class="box-link">
		  				<h6 v-if="row3 && row3.text && row3.text[0] && row3.text[0].value">{{ row3.text[0].value }}</h6>
		  				<h3 v-if="row3 && row3.text && row3.text[1] && row3.text[1].value">{{ row3.text[1].value }} &nbsp;&nbsp;<img src="../assets/green-cnr.png" width="15"></h3>
	  				</div>
	  			</div>
	  			<div class="col-md-6">
	  				&nbsp;
	  			</div>
	  		</div>
	  	</div>
	  </div>
	  <div>&nbsp;</div>
  </div>
</template>

<script>
import slide1 from '@/assets/slide1.jpg'
import slide2 from '@/assets/slide2.jpg'
import slide3 from '@/assets/grey-abstract.jpg'

import { RepositoryFactory } from "@/repositories/RepositoryFactory"
const ContentRepository = RepositoryFactory.get("content");

export default {
  name: "home",
  data: function(){
  	return {
  		browserHeight: window.screen.availHeight,
  		scrollPos: 0,
  		currentBox: 1,
  		slide: 0,
  		slides:[],
  		row1: [],
  		row2: {},
  		row3: {},
  		slide1:slide1,
  		slide2:slide2,
  		slide3:slide3
  	}
  },
  methods:{
  	handleScroll(){

  		var singleHeight = Number(this.browserHeight)
  		var doubleHeight = Number(this.browserHeight) * 2
  		var absPosition = Math.abs(this.scrollPos)

  		if ((document.body.getBoundingClientRect()).top > this.scrollPos){

  			if (absPosition <= doubleHeight && absPosition >= singleHeight) {
  				this.$scrollTo('#box2', 500)
  			} else {
  				this.$scrollTo('#video', 500)
  			}
  			
  		} else {

  			if (absPosition >= singleHeight){
  				this.$scrollTo('#box3', 500)
  			}  else {
  				this.$scrollTo('#box2', 500)
  			}
  		}

  		this.scrollPos = (document.body.getBoundingClientRect()).top;
  		
  	},
  	async loadContent(){
  		var type = "home_page"
        var id = "20"
        const { data } = await ContentRepository.get(type, id)

        var home = data[0]

        this.slides = home.field_slide_image

        this.row1 = home.field_lines

        this.row2 = {
        	image: home.field_box_2_image,
        	text: home.field_box_2_text
        }

        this.row3 = {
        	image: home.field_box_3,
        	text: home.field_box_3_text
        }
  	},
  	getPage(obj){

  		var objPath = ''
  		if (obj && obj.text && obj.text[2] && obj.text[2].value){
  			objPath = obj.text[2].value
  		} 

  		if (obj && obj.value){
  			objPath = obj.value
  		}

  		if (objPath != ''){
  			this.$router.push(objPath)
  		}
  		
  	}
  },

  mounted () {
  	this.loadContent()
    // window.addEventListener('scroll', this.handleScroll);
  }
};
</script>

<style scoped>
	.video-slide, .box-2, .box-3{
		height:100vh;
		width:100%;
		z-index:-5;
		margin:0px;
		padding:0px;
		overflow:hidden;
	}

	.box-link{
		cursor:pointer;
	}

	#carousel-1{
		text-shadow: 1px 1px 2px #333;
	}

	video {
	  object-fit: fill;
	  height:100vh;

	}

	.home h6{
		text-transform:uppercase;
	}

	.box2arrow{
		color:#FFFFFF;
		margin-left:10px;
		display:block;
		margin-top:20px
	}

	.box2anchor{
		margin-left:10px;
		color:#FFF;
		display:block;
		margin-top:20px;
		margin-bottom:20px;
	}

	#carousel-1{
		height:100vh;
	}

	#carousel-1 .carousel-item.active{
		height:100vh;
	}

	.w-100{
		width:auto !important;
		height:100vh;
	}

	.capabilities-text{
		padding-right:18%;
		text-align:right !important;
		color:#FFF !important;
		position:relative;
		z-index:20;
		padding-top:52vh !important;
	}

	.capabilities-text a{
		color:#FFF;
	}

	.overlay{
		position:absolute;
		top:40vh;
		left:20%;
		overflow:hidden;
		text-align:left;
		z-index:100;
	}

	.box3text{
		padding-left:50px;
		color:#333;
		padding-top:5vh;
	}

	.indicators{
		font-size:120%;
		xpadding:10px;
		color:#000;
		position:fixed;
		bottom:5px;
		right:10px;
		xborder:1px solid red;
		z-index:500;
	}

	.indicators div{
		margin-bottom:10px;
	}

	.indicators a{
		color:#000;
	}

	.xindicators{
		position:absolute;
		z-index:100;
		bottom:20px;
		left:20%;
		background:rgba(255,255,255,0.8);
		padding:5px;
	}

	.row .col-sm-5, .row .col-sm-7, .row .col-sm-6, .row .col-md-6{
		height:100vh;
		padding-top:30vh;
	}

	#box3 .row .col-sm-5, #box3 .row .col-sm-7, #box3 .row .col-sm-6, #box3 .row .col-md-6{
		height:100vh;
		padding-top:15vh;
		color:#000;
		text-align:left;
	}

	#box2 img, #box3 img{
		max-width:90%;
	}

	#box2 .col-sm-7, #box2 .col-sm-6{
		color:#FFF;
		text-align:left;
	}

	#box2 .col-sm-7{
		padding-right:300px !important;
	}

	#box3 .col-sm-7, #box3 .col-sm-6, #box3 .col-md-6{
		text-align:left;
	}


	#box2 .indicators, #box2 .indicators a{
		color:#33ccff;
	}

	.overlay h1{
		background:rgba(255,255,255,0.9);
		color:#000;
		padding:5px 10px;
		display:inline-block;
		font-weight:bold;
	}

	.box-2{
		/*background-image:url('../assets/grey-trig-background.jpg');*/
		background-size:cover;
	}

	.box-3{
		/*background-image:url('../assets/our-people-4.jpg');*/
		background-size:cover;
	}

	

	.video-slide{	
		background:url('../assets/slide1.png') no-repeat center center;
		background-size:cover;
	}

	.blue-triangle{
		background:url('../assets/blue-gradient-triangle.png') no-repeat center center;
		background-size:cover;
		height:130vh;
		width:100%;
		top:70vh;
		position:absolute;
		z-index:10;
	}

	.grey-triangle{
		background:url('../assets/grey-triangle-overlay.png') no-repeat center center;
		background-size:cover;
		height:100vh;
		width:100%;
		position:absolute;
		z-index:0;
	}

	.carousel-inner .img-fluid{
		height:100vh;
	}

	@media (max-width:768px){
		.box-3 .col-sm-6, .box-3 .col-md-6{
			padding-top:200px !important;
			background:rgba(255,255,255,0.5);
		}
	}


</style>
